import { CoverageCheckbox as CoverageCheckboxSchema } from '@/schemas/sceneDataSchema';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { Checkbox } from '@mui/material';

export default function CoverageCheckboxFormElement({ component }: { component: CoverageCheckboxSchema }) {
  const fieldName = encodeFieldKey(component);
  return (
    <Checkbox
      id={fieldName}
      name={fieldName}
      onChange={() => {}}
      value={component.value ?? false}
      checked={component.value ?? false}
    />
  );
}
